import React from 'react';
import styled from 'styled-components';

// seasonbakery custom

const iconSize = 16;

export default function MobileNavDrawer(props) {
  const {visible, setVisible} = props;

  return (
    <>
      <Backdrop visible={visible} onClick={() => setVisible(false)} />
      <MobileContent visible={visible}>
        <div className="header">
          <button onClick={() => setVisible(false)} className="close">
            <svg width={iconSize} height={iconSize}>
              <use xlinkHref="/images/icon-close.svg#_圖層_2" />
            </svg>
          </button>
        </div>
        {props.children}
      </MobileContent>
    </>
  );
}

const Backdrop = styled.div`
  z-index: 101;
  position: fixed;
  right: 0;
  // top: var(--topNavBarHeight);
  top: 0;
  width: 100vw;
  height: 100vh;
  opacity: ${(props) => (props.visible ? 1 : 0)};
  pointer-events: ${(props) => (props.visible ? 'auto' : 'none')};
  transition: 400ms;
  /* background-color: rgba(0, 0, 0, 0.5); */
`;

const MobileContent = styled.div`
  z-index: 101;
  position: fixed;
  left: 0;
  // top: var(--topNavBarHeight);
  top: 0;
  width: 394px;
  max-width: 100vw;
  height: 100vh;
  /* background-color: rgba(255, 255, 255, 0.95); */
  background-color: var(--background-color);
  border-right: 0.75px solid var(--border-color);
  // box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.31);
  display: flex;
  flex-direction: column;
  transition: 400ms;
  pointer-events: ${(props) => (props.visible ? 'auto' : 'none')};
  opacity: ${(props) => (props.visible ? 1 : 0)};
  transform: ${(props) =>
    props.visible ? 'translateX(0px)' : 'translateX(-400px)'};
  padding-left: 80px;
  padding-right: 40px;

  & > .header {
    height: var(--topNavBarHeight);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 40px;

    & > button.close {
      background-color: transparent;
      outline: none;
      border: none;
      box-shadow: none;
      padding: 0;
      color: var(--icon-color);
      cursor: pointer;
    }
  }

  & > .nav-items {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 250px);
    overflow: auto;

    & > * {
      &.default {
        margin-bottom: 16px;
        font-size: 1.1rem;
        color: #646464;
        letter-spacing: 0.2em;
        font-weight: 300;
      }

      &.default-child {
        margin-bottom: 16px;
        font-size: 1.1rem;
        color: #646464;
      }

      &.selected {
        color: var(--primaryColor);
      }
    }
  }
`;
